import type { ModuleTagEntry } from './index';

/** PET Isotope module tags. */
export const tags: ModuleTagEntry[] = [['RadiopharmaceuticalInfo', '00540016']];
